import { differenceInDays, format, parseISO } from 'date-fns';

interface GenderInputClassNames {
  styles: {
    [key: string]: string;
  };
  selected: string;
  error: boolean;
}

export const isWithinTwoDays = (scanDate: Date | string | null) => {
  if (!scanDate) return false;
  if (typeof scanDate === 'string') scanDate = new Date(scanDate);
  return differenceInDays(scanDate, new Date()) <= 2;
};

export const genderMap = (gender: string | null) => {
  switch (gender) {
    case 'male':
    case 'female':
      return gender;
    default:
      return '';
  }
};

export const getGenderSelectClassName = ({ styles, selected, error }: GenderInputClassNames) => {
  return `${selected ? '' : styles.genderSelector} ${styles.genderSelectorStyle} ${error ? styles.invalidGenderSelector : ''}`;
};

export const getCurrentUser = (user: any) => ({
  ...user,
  dob: user?.dob ? format(parseISO(user.dob), 'MM/dd/yyyy') : '',
  isLoggedIn: true,
  firstName: user.firstname,
  lastName: user.lastname,
  gender: genderMap(user?.gender),
});
